import { ConnectError } from '@connectrpc/connect';
import { notifyBugsnag } from '../services/bugsnag';

export default async function handleConnectCall(fn, bugsnagData) {
  try {
    return await fn();
  } catch (error) {
    const connectError = ConnectError.from(error);

    notifyBugsnag(bugsnagData.errorClass, {
      context: bugsnagData.context,
      breadcrumb: bugsnagData.breadcrumb,
      info: {
        ...bugsnagData.info,
        code: connectError.code,
        message: connectError.rawMessage,
      },
      response: connectError,
      errorMessage: connectError.message,
    });

    return Promise.reject(connectError);
  }
}
